import React, {useEffect} from 'react';
import {JazeemInventoryEvent, JazeemInventoryEventsSubscription} from "src/API";
import {API, graphqlOperation} from "aws-amplify";
import {GraphQLSubscription} from "@aws-amplify/api"
import {jazeemInventoryEvents} from "src/graphql/subscriptions";
import useStore from "src/store";
import {LIVE} from "src/globalVariables/globalVariables";


function AppSyncEvents() {

  const addInventoryEvent = useStore(state => state.addInventoryEvent);

  useEffect(() => {
    API.graphql<GraphQLSubscription<JazeemInventoryEventsSubscription>>(
        graphqlOperation(jazeemInventoryEvents)
    ).subscribe({
      next: ({ provider, value }) => {
        if (value.data?.jazeemInventoryEvents) {
          // These are all checkout events at the moment, due to filtering that happens in the lambda.
          value.data.jazeemInventoryEvents.events.forEach((event) => {
            addInventoryEvent(event, LIVE);
          });
        }
      },
      error: (error) => console.warn(error)
    });

  }, []);

  return (
      <>
      </>
  );
}

export default AppSyncEvents;